import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Select } from "antd";
import ServiceRequestFinished from "../components/MyOrders/ServiceRequestFinished";
import { fetchOrdersByStatus } from "../redux/orderStatusSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const AllOrders = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [filter, setFilter] = useState("all");

    const handleChange = (value) => {
        setFilter(value);
    };

    const dispatch = useDispatch();

    const [selectedStatusFin, setSelectedStatusFin] = useState("finished");
    const [ordersFin, setOrdersFin] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchOrdersByStatus(selectedStatusFin)
                ).unwrap();

                setOrdersFin(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatusFin, dispatch]);

    return (
        <div className="all_orders">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8 sticky top-0">
                <Link to="/myorders" className='flex items-center text-[#283D63] font-semibold'>
                    {
                        language == "en" ? <>
                            <LeftOutlined />
                            <p className='ml-3'>{t("Back to my orders")}</p>
                        </> : <>
                            <RightOutlined />
                            <p className='mr-3'>{t("Back to my orders")}</p>
                        </>
                    }
                </Link>

                <div className="lg:flex items-center justify-between mt-8">
                    <div className="flex items-center">
                        <h2 className="text-[#14294F] font-semibold text-2xl">{t("All Orders")}</h2>
                    </div>
                    <div className="flex items-center max-lg:mt-4">
                        <p className={`${language == "en" ? "mr-3" : "ml-3"} text-[#283D63] font-semibold`}>{t("Filter")}</p>
                        <Select
                            defaultValue="all"
                            style={{
                                width: 220,
                            }}
                            className="border-2 border-[#4F71A8] rounded-full"
                            onChange={handleChange}
                            options={[
                                {
                                    value: "all",
                                    label: t("All"),
                                },
                                {
                                    value: "Store_orders",
                                    label: t("Store orders"),
                                },
                                {
                                    value: "Service_requests",
                                    label: t("Service requests"),
                                },
                            ]}
                        />
                    </div>
                </div>

            </div>
            <div className="chat-box px-20 max-lg:px-5 py-5 pb-20">
                {filter === "all" && (
                    <>
                        <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                            {ordersFin?.data?.length > 0 ? (
                                ordersFin?.data?.map((orderr, index) => (
                                    <ServiceRequestFinished
                                        key={index}
                                        idOrder={orderr.id}
                                        orderStatus={orderr.status}
                                        date={orderr.date}
                                        time={orderr.time}
                                        image={`https://service.samoolah.com/${orderr.category.icon}`}
                                    />
                                ))
                            ) : (
                                <p className="text-center text-2xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                                    {t("No orders")}
                                </p>
                            )}
                        </div>
                        <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">

                        </div>
                    </>
                )}

                {filter === "Service_requests" && (
                    <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                        {ordersFin?.data?.length > 0 ? (
                            ordersFin?.data?.map((orderr, index) => (
                                <ServiceRequestFinished
                                    key={index}
                                    idOrder={orderr.id}
                                    orderStatus={orderr.status}
                                    date={orderr.date}
                                    time={orderr.time}
                                    image={`https://service.samoolah.com/${orderr.category.icon}`}
                                />
                            ))
                        ) : (
                            <p className="text-center text-2xl text-[#FE9B71] col-span-2 mt-7 pt-7">
                                {t("No orders")}
                            </p>
                        )}
                    </div>
                )}

                {filter === "Store_orders" && (
                    <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                        <p className="text-center text-2xl max-lg:text-lg text-[#FE9B71] col-span-2 lg:mt-7 pt-7">
                            {t("No store orders")}
                        </p>
                    </div>
                )}

            </div>
        </div>

    );
};

export default AllOrders;
